import { render, staticRenderFns } from "./@popupPerformance.vue?vue&type=template&id=0468ff20&scoped=true&"
import script from "./@popupPerformance.vue?vue&type=script&lang=js&"
export * from "./@popupPerformance.vue?vue&type=script&lang=js&"
import style0 from "./@popupPerformance.vue?vue&type=style&index=0&id=0468ff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0468ff20",
  null
  
)

export default component.exports